import { EnrichedBacklogMetricsByWorkstream } from '@/pages/OperationsInsights/types/BacklogMetricsResponseEnriched';
/**
 * Transform Backlog In / Out and (Average Time To Resolution) by workstream
 *
 * @param metrics
 */
export const tfCsBLInOutByWorkstreamMetrics = (metrics: EnrichedBacklogMetricsByWorkstream[]) => {

    const xAxisCategories: string[] = [];
    const chartSeries = [
        {
            type: 'column' as const,
            name: 'Created',
            yAxis: 'yaxis-left',
            color: '#2caffe', // light-blue
            data: [] as number[][]
        },
        {
            type: 'column' as const,
            name: 'Completed',
            yAxis: 'yaxis-left',
            color: '#a2d7f1', // super light blue
            data: [] as number[][]
        },
        {
            type: 'line' as const,
            name: 'Avg Time to Resolution (hours)',
            yAxis: 'yaxis-right',
            color: 'black',
            data: [] as number[][]
        }
    ];
    for (const metric of metrics) {

        xAxisCategories.push(metric.name);

        // Created
        chartSeries[0].data.push([ xAxisCategories.length - 1, metric.createdCount ]);

        // Completed
        chartSeries[1].data.push([ xAxisCategories.length - 1, metric.closedCount ]);

        // Average Time To Resolution (Average of the duration between start time and final resolution time)
        const avgTimeToResolutionInHour = metric.averageResolutionTimeInHour ?? 0;
        chartSeries[2].data.push([ xAxisCategories.length - 1, avgTimeToResolutionInHour ]);
    }
    return { xAxisCategories, chartSeries };
};